import { Yield } from '../../abacus/interfaces/yield.interface'

export const requiredSkillYields: Yield[] = [
  {
    label: 'Name',
    property: 'name'
  },
  {
    label: 'Description',
    property: 'description'
  }
]
